import { Injectable } from '@angular/core';
import {FileSelectorModel} from '@features/file-manager/models/file-selector.model';
import {DialogService} from '@shared/services/dialog-service';
import {take} from 'rxjs/operators';
import {SnackBarService} from '@core/services/snack-bar.service';

@Injectable({
  providedIn: 'root'
})
export class VirtualWorkbookWorksheetService {

  constructor(  private dialogService: DialogService,  private snackBarService: SnackBarService) { }


}
